import Constant from '@/common/constant/Constant';
import Utils from '@/common/utils/utils';
import { Tooltip } from '@material-ui/core';
// import { useState } from 'react';
import { downloadFileFromS3, getLinkDownloadFileFromS3 } from '../common/FileUploaded';

export default function DetailTicketListThumbnail(props) {
    const { ticket } = props;

    // const [anchorEl, setAnchorEl] = useState(null);
    // const open = Boolean(anchorEl);

    const handleClick = (event, fileUploadInfor) => {
        // setAnchorEl(event.currentTarget);
        let item = {
            content: fileUploadInfor.fileName,
            fileSize: parseInt(fileUploadInfor.fileSize),
            fileUrl: fileUploadInfor.fileUrl,
            type: 1
        };
        downloadFileFromS3(item, ticket, false, false, '', props?.setIsShowPopupLogout);
    };

    let view = Constant.ATTACH_FILE.VIEW_TICKET;

    return (
        <div className="ticket-thumbnail-frame">
            <div className="ticketThumb">
                <ul>
                    {ticket.attachment?.map((file, index, array) => {
                        if (array?.length > Constant.ATTACHMENT_DISPLAY_LIMIT &&index >= Constant.ATTACHMENT_DISPLAY_LIMIT - 1) {
                            return <></>;
                        }
                        return (
                            <>
                                <Tooltip
                                    title={file.fileName}
                                    aria-label={file.fileName}
                                    key={index}
                                >
                                    <li>
                                        <img
                                            src={
                                                Utils.isImageFile(file.fileName)
                                                    ? getLinkDownloadFileFromS3(
                                                          { ...file, type: 1 },
                                                          ticket,
                                                          null,
                                                          view
                                                      )
                                                    : '/assets/image/others_file.png'
                                            }
                                            alt=""
                                            aria-label="more"
                                            aria-controls="long-menu"
                                            aria-haspopup="true"
                                            onClick={event => handleClick(event, file)}
                                        />
                                    </li>
                                </Tooltip>
                            </>
                        );
                    })}
                    {ticket?.attachment?.length > Constant.ATTACHMENT_DISPLAY_LIMIT && (
                        <li>
                            <a href="javascript:void(0)">
                                {/* <img
                                    src={
                                        Utils.isImageFile(ticket?.attachment[3].fileName)
                                            ? getLinkDownloadFileFromS3(
                                                  { ...ticket?.attachment[3], type: 1 },
                                                  ticket,
                                                  null,
                                                  view
                                              )
                                            : '/assets/image/others_file.png'
                                    }
                                    alt=""
                                /> */}
                                <span className="ticketThumb-number">
                                    {ticket?.attachment?.length - (Constant.ATTACHMENT_DISPLAY_LIMIT - 1)}+
                                </span>
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        </div>
    );
}
